module.exports = __webpack_public_path__ + "img/ticket-background.d423f891.svg";